import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {Status} from "../../../common/constants";
import { listPublicApiTokensUrl } from "../../../config"
import api from '../../../api';

export interface IPublicApiToken {
  entryId: string;
  userEmail: string;
  tokenName: string;
  issuedAt: string;   
  expiresAt: number | "never" | null;
}

interface IPublicApiTokensState {
  tokens: any;
  status: string;
  error: string | null;
  dataFetched: boolean;
}

const initialState: IPublicApiTokensState = {
  tokens: {},
  status: Status.IDLE,
  error: null,
  dataFetched: false,
};

// Async thunk to list public API tokens
export const listPublicApiTokens: any = createAsyncThunk(
  'listPublicApiTokens',
  async () => {
    try {
      const response = await api.get(listPublicApiTokensUrl);
      return response.data;  // expected to be IPublicApiToken[]
    } catch (error) {
      throw error;
    }
  }
);

// Create slice
const listPublicApiTokensSlice = createSlice({
  name: 'listPublicApiTokens',
  initialState,
  reducers: {
    setDataFetched: (state, action) => {
      state.dataFetched = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listPublicApiTokens.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(listPublicApiTokens.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.tokens = action.payload;
      })
      .addCase(listPublicApiTokens.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message ?? null;
      });
  },
});

type Selector = {
  listPublicApiTokens: ReturnType<typeof listPublicApiTokensSlice.reducer>;
};

export const selector = (store: Selector) => store['listPublicApiTokens'];

export default listPublicApiTokensSlice.reducer;
export const { setDataFetched } = listPublicApiTokensSlice.actions;
